import React, { Component, Fragment } from "react";
import cx from "classnames";
import VerticalNavWrapper from "./AppNav/VerticalNavWrapper";
import HeaderLogo from "./AppLogo";
import { ThemeOptions } from "../ThemeOptions";
import { CSSTransitionComponent } from "../components/CSSTransition";

interface SidebarProps {
    visible: boolean;
    closeSidebar: () => void;
}

class AppSidebar extends Component<SidebarProps> {
    state = {};

    toggleMobileSidebar = () => {};

    render() {
        const { visible, closeSidebar } = this.props;
        const { backgroundColor, enableSidebarShadow } = ThemeOptions;

        return (
            <Fragment>
                <VerticalNavWrapper visible={visible} closeSidebar={closeSidebar} />
                {/* <div className="sidebar-mobile-overlay" onClick={this.toggleMobileSidebar} />
                <CSSTransitionComponent>
                    <div
                        className={cx("app-sidebar !pt-20", backgroundColor, {
                            "sidebar-shadow": enableSidebarShadow,
                        })}
                    >
                        <HeaderLogo />
                        <div className="app-sidebar__inner">
                            <VerticalNavWrapper />
                        </div>
                    </div>
                </CSSTransitionComponent> */}
            </Fragment>
        );
    }
}

export default AppSidebar;
